export var cifMc = ["301 241", "<g fill='none'><path fill='#CE1126' d='M.5.5h300v120H.5z'/><path fill='#FFF' d='M.5 120.5h300v120H.5z'/></g>"];
